export const FixedProstheticsPriceData = [
    {
        id: 1,   
        service: 'Металлокерамическая коронка',
        price: '16000',
    },
    {
        id: 2,
        service: 'Коронка на основе диоксида циркония',
        price: '26000',
    },
    {
        id: 3,
        service: 'Цельнокерамическая коронка',
        price: '22000',
    },
    {
        id: 4,
        service: 'Восстановление зуба виниром',
        price: '25000',
    },
]
export const RemovableProstheticsPriceData = [
    {
        id: 1,   
        service: 'Протезирование бюгельными протезами ',
        price: '75000 - 100000',
    },
    {
        id: 2,
        service: 'Протезирование пластинчатыми протезами',
        price: '25000',
    },
    {
        id: 3,
        service: 'Изготовление съемного протеза на балке (4 имплантата)',
        price: '180000',
    },
    {
        id: 4,
        service: 'Починка съемного протеза',
        price: '5000',
    },
]

export const ImplantProstheticsPriceData = [
    {
        id: 1,   
        service: 'Цельнокерамическая коронка, индивидуальный абатмент',
        price: '45000',
    },
    {
        id: 2,
        service: 'Коронка на основе диоксида циркония ',
        price: '35000',
    },
]